import desktop_1954 from 'app/assets/images/timeline/1954-desktop.jpg'
import mobile_1954 from 'app/assets/images/timeline/1954-mobile.jpg'
import desktop_1957 from 'app/assets/images/timeline/1957-desktop.jpg'
import mobile_1957 from 'app/assets/images/timeline/1957-mobile.jpg'
import desktop_1963 from 'app/assets/images/timeline/1963-desktop.jpg'
import mobile_1963 from 'app/assets/images/timeline/1963-mobile.jpg'
import desktop_1975 from 'app/assets/images/timeline/1975-desktop.jpg'
import mobile_1975 from 'app/assets/images/timeline/1975-mobile.jpg'
import desktop_2012 from 'app/assets/images/timeline/2012-desktop.jpg'
import mobile_2012 from 'app/assets/images/timeline/2012-mobile.jpg'
import desktop_2018 from 'app/assets/images/timeline/2018-desktop.jpg'
import mobile_2018 from 'app/assets/images/timeline/2018-mobile.jpg'

const tiles = [
    {
        date: '1954',
        title: 'La plus grande invention depuis la roue',
        story:
            'Deux jeunes hommes qui cherchent à changer le monde dans un garage\u00A0:\u00A0ça donne souvent de grandes réussites. C’est le 4\u00A0décembre\u00A01954 à Miami que James McLamore & David Edgerton ouvrent leur premier BURGER KING®.',
        images: {
            desktop: desktop_1954,
            mobile: mobile_1954
        },
        shadow: 'rgba(196, 52, 42, 0.2)'
    },
    {
        date: '1957',
        title: 'Et le whopper® fut',
        story:
            "L'année 1957, ou l'an 0 burger. On avait l'écrin, voici le joyau. Avec sa viande grillée à la flamme et ses ingrédients frais\u00A0:\u00A0il a déjà tout d'un roi.",
        images: {
            desktop: desktop_1957,
            mobile: mobile_1957
        },
        shadow: 'rgba(196, 52, 42, 0.2)'
    },
    {
        date: '1963',
        title: 'Le royaume part à la conquête du monde',
        story:
            "Cette année marque notre ouverture au monde. Ça y est, le premier BURGER KING® en dehors des États-Unis voit le jour et c'est à San Juan, Puerto Rico précisément.",
        images: {
            desktop: desktop_1963,
            mobile: mobile_1963
        },
        shadow: 'rgba(176, 52, 202, 0.2)'
    },
    {
        date: '1975',
        title: 'Viva el whopper\u00A0!',
        story:
            'Les tapas, ça va 5 min. Du coup on a voulu faire un chouette cadeau aux Madrilènes en ouvrant notre tout premier restaurant européen chez eux.',
        images: {
            desktop: desktop_1975,
            mobile: mobile_1975
        },
        shadow: 'rgba(223, 86, 58, 0.2)'
    },
    {
        date: '2012',
        title: 'Retour de la monarchie absolue',
        story:
            "L'appel du peuple était fort. Après 15\u00A0ans d'absence dans l'hexagone, le groupe Bertrand signe la master franchise Burger King® et obtient ainsi le droit exclusif de développer la marque en France.",
        images: {
            desktop: desktop_2012,
            mobile: mobile_2012
        },
        shadow: 'rgba(187, 30, 51, 0.2)'
    },
    {
        date: '2018',
        title: "Vous n'avez pas fini d'en déguster",
        story:
            "Le phénomène s'est répandu dans toute la France et BURGER KING® a ouvert plus de 250 restaurants. Vous n'avez pas tout vu. To be continued\u00A0...",
        images: {
            desktop: desktop_2018,
            mobile: mobile_2018
        },
        shadow: 'rgba(255, 198, 81, 0.2)'
    }
]

export { tiles }
